/* eslint-disable jsx-a11y/anchor-has-content */
import React, { FC } from 'react'
import { Link } from 'gatsby'
import { LinkI } from '../types/common'
import { SocialI } from '../types/data-models'

interface SidebarI {
  menuLinks: LinkI[]
  toggleMenu: () => void
  social: SocialI
}
const Sidebar: FC<SidebarI> = ({ menuLinks, toggleMenu, social }) => {
  return (
    <div id="navPanel">
      <nav id="menu">
        <ul className="links">
          {menuLinks.map((link) => (
            <li key={link.label} className="nav-home active">
              <Link to={link.url}>{link.label}</Link>
            </li>
          ))}
        </ul>
        <ul className="icons alt">
          {Object.keys(social).map((keyName, i) => (
            <li key={i}>
              <a href={social[keyName as keyof SocialI]} className={`icon fa-${keyName}`}>
                <span className="label">{keyName}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <a href="#navPanel" className="close" onClick={toggleMenu}></a>
    </div>
  )
}

export default Sidebar
